"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganisationFileUploadType = void 0;
var OrganisationFileUploadType;
(function (OrganisationFileUploadType) {
    OrganisationFileUploadType["ORGANISATION_PROFILE_CERTIFICATE"] = "ORGANISATION_PROFILE_CERTIFICATE";
    OrganisationFileUploadType["ORGANISATION_PROFILE_DOCUMENT"] = "ORGANISATION_PROFILE_DOCUMENT";
})(OrganisationFileUploadType = exports.OrganisationFileUploadType || (exports.OrganisationFileUploadType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JnYW5pc2F0aW9uLWZpbGUtdXBsb2FkLWVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tbW9uL2VudW1zL29yZ2FuaXNhdGlvbi1maWxlLXVwbG9hZC1lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksMEJBR1g7QUFIRCxXQUFZLDBCQUEwQjtJQUNwQyxtR0FBcUUsQ0FBQTtJQUNyRSw2RkFBK0QsQ0FBQTtBQUNqRSxDQUFDLEVBSFcsMEJBQTBCLEdBQTFCLGtDQUEwQixLQUExQixrQ0FBMEIsUUFHckMifQ==